import { Flex, Tooltip } from 'antd'
import React, { useEffect } from 'react'
import {
    LikeOutlined,
    DislikeOutlined,
    HistoryOutlined,
} from '@ant-design/icons';

const SingleVoteRender = ({ docVoteData, colorPrimary, colorWarning, colorError, borderRadiusLG }) => {

    useEffect(() => {
        // console.log("docVoteData :", docVoteData)
    }, [docVoteData])

    return (
        <div>
            <Flex justify='flex-start' align='center' gap={12}>
                <Tooltip
                    title={`Accepted: ${docVoteData?.isEnabled ? docVoteData?.count?.approve ?? 0 : 0}`}
                    placement='bottom'
                >
                    <Flex
                        justify='flex-start'
                        align='center'
                        gap={4}
                        style={{
                            marginBlockStart:5,
                            // backgroundColor: colorPrimary,
                            // paddingLeft: 8,
                            // paddingRight: 8,
                            // borderRadius: borderRadiusLG,
                            fontSize: 14,
                        }}
                    >
                        <LikeOutlined />
                        {docVoteData?.isEnabled ? docVoteData?.count?.approve ?? 0 : 0}
                    </Flex>
                </Tooltip>
                
                <Tooltip
                    title={`Abstain : ${docVoteData?.isEnabled ? docVoteData?.count?.abstain ?? 0 : 0}`}
                    placement='bottom'
                >
                    <Flex
                        justify='flex-start'
                        align='center'
                        gap={4}
                        style={{
                            marginBlockStart:5,
                            // backgroundColor: colorWarning,
                            // paddingLeft: 8,
                            // paddingRight: 8,
                            // borderRadius: borderRadiusLG,
                            fontSize: 14,
                        }}
                    >
                        <HistoryOutlined />
                        {docVoteData?.isEnabled ? docVoteData?.count?.abstain ?? 0 : 0}
                    </Flex>
                </Tooltip>
                
                <Tooltip
                    title={`Reject : ${docVoteData?.isEnabled ? docVoteData?.count?.reject ?? 0 : 0}`}
                    placement='bottom'
                >
                    <Flex
                        justify='flex-start'
                        align='center'
                        gap={4}
                        style={{
                            marginBlockStart:5,
                            // backgroundColor: colorError,
                            // paddingLeft: 8,
                            // paddingRight: 8,
                            // borderRadius: borderRadiusLG,
                            fontSize: 14,
                        }}
                    >
                        <DislikeOutlined />
                        {docVoteData?.isEnabled ? docVoteData?.count?.reject ?? 0 : 0}
                    </Flex>
                </Tooltip>
            </Flex>
        </div>
    )
}

export default SingleVoteRender